export default __webpack_public_path__ + "static/media/whitepaper.f7d99e3b.pdf";